import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import CustomDynamicBox from "~/CustomDynamicBox.jsx";
import store from "./store";

const root = createRoot(document.getElementById("custom-dynamic-box-root"));

root.render(
  <StrictMode>
    <Provider store={store}>
      <CustomDynamicBox />
    </Provider>
  </StrictMode>
);
